import { StoreState } from '@/redux/types';
import { getDraft } from './getDraft';

export const getCurrentView = (state: StoreState) => getDraft(state).view;
